import { FC, useEffect, useState } from 'react'
import * as Yup from 'yup'
import { ErrorMessage, Field, FieldArray, Form, Formik, FormikErrors } from 'formik'
import { API_IMG_AVATR, API_IMG_SPECIAL_FILE, Adapter, CommonService, IFormSpecialAssess, Pattern, SeasonDto, SpecialAssessRequestDto, SpecialService } from '../../modules/core'
import { catchErrorMsg } from '../../modules/core/helpers/Helper'
import { toast } from 'react-toastify'
import { useNavigate, useParams } from 'react-router-dom'
import { FormDataPicker, FormInputNumber, FormRadio } from 'app/components'
import { PageTitle } from '_metronic/layout/core'
import { RootState } from 'setup'
import { shallowEqual, useSelector } from 'react-redux'
import moment from 'moment'
import { FormUpload } from 'app/components/formInputs/FormUpload'

type Props = {

}

let initValue: IFormSpecialAssess = {
    seasonId: 0,
    assessTypeId: 2,
    title: '',
    point: 0,
    recordDate: new Date(),
    file: null
}

const formSchema = Yup.object().shape({
    title: Yup.string().required('require'),
    recordDate: Yup.date().required('require'),
    point: Yup.number().required('require'),
})



export const SpecialDetailPage: FC<Props> = () => {

    const lastSeason = useSelector<RootState>(({ core }) => core.lastSeason, shallowEqual) as SeasonDto
    const [loading, setLoading] = useState(true)
    const [data, setData] = useState<IFormSpecialAssess>(initValue)


    const { id } = useParams()
    const navigate = useNavigate()
    useEffect(() => {
        const init = () => {
            if (id && id !== 'new') {
                //setSeasonMonth()
                SpecialService.GetById(parseInt(id)).then((result) => {
                    const res = result.data.result
                    if (res) {
                        const frmDto = Adapter.FormSpecialAssess(res);
                        setData(frmDto)
                    }

                })
            }
            setLoading(false)
        }
        init()
    }, [id])

    const onSubmit = async (values: IFormSpecialAssess) => {
        setLoading(true)

        if (!lastSeason?.id) {
            toast.error('season โหลดไม่ถูกต้อง')
            return
        }

        // const d = moment(seasonMonth).toDate();
        const updatedData = Adapter.mapSpecialAsess(values)
        updatedData.seasonId = lastSeason?.id
        if (id === 'new') {
            Save(updatedData)
        } else if (id) {
            Update(parseInt(id), updatedData)
        }


    }

    const Save = (updatedData: SpecialAssessRequestDto) => {
        SpecialService.Create(updatedData)
        .then((res) => {
            toast.success('Save Success.')
            navigate('/special')
        }).catch((res) => {
            toast.error(catchErrorMsg(res))
            setLoading(false)
        })
    }

    const Update = (id: number, updatedData: SpecialAssessRequestDto) => {
        SpecialService.Update(id, updatedData).then(() => {
            toast.success('Update Success.')
            navigate('/special')
        }).catch((res) => {
            toast.error(catchErrorMsg(res))
            setLoading(false)
        })
    }


    const CellStyle: React.FC<{ lable: string, children?: React.ReactNode }> = (props) => {
        return (
            <div className='row mb-7'>
                <label className='col-lg-4 fw-bold'>{props.lable}</label>

                <div className='col-lg-4'>
                    <span className='fw-bolder fs-6 text-dark'>{props.children}</span>
                </div>
            </div>
        )
    }
    let minDate: Date | undefined = undefined;
    let maxDate: Date | undefined = undefined;
    if (lastSeason) {
        minDate = new Date(lastSeason.periodStart)
        const t_maxDate = new Date(lastSeason.periodEnd)
        maxDate = new Date(t_maxDate.getFullYear(), t_maxDate.getMonth() + 1, 0)
    }

    return (
        <>
            <PageTitle
                breadcrumbs={[
                    {
                        title: 'ประเมินตนเอง',
                        path: '/selfAssess',
                        isSeparator: false,
                        isActive: false,
                    },
                ]}
            >
                คะแนนพิเศษ
            </PageTitle>
            <div className='card mb-5 mb-xl-10'>
                <div className='card-header cursor-pointer'>
                    <div className='card-title m-0 '>
                        <h3 className='fw-bolder py-2'>{lastSeason?.title}</h3>
                        <h3 className='fw-bolder ps-5'>{lastSeason ? `${moment(lastSeason.periodStart).format("YYYY MMM")} - ${moment(lastSeason.periodEnd).format("YYYY MMM")}` : ""}</h3>
                    </div>
                </div>
                <Formik
                    enableReinitialize
                    initialValues={data}
                    validationSchema={formSchema}
                    onSubmit={onSubmit}
                // validate={(v) => console.log(v)}
                >
                    {({ values, handleSubmit, setFieldValue, errors, touched }) => (
                        <Form>
                            <>
                                {/* begin::Scroll */}
                                <div className='card-body p-9'>
                                    <CellStyle lable='วันที่'>
                                        <Field
                                            as='text'
                                            name='recordDate'
                                            className={
                                                'form-control form-control-solid' +
                                                (errors.recordDate && touched.recordDate ? ' is-invalid' : '')
                                            }
                                            value={moment(values.recordDate).format('DD/MM/YYYY')}
                                            onDateChange={(value: Date, e: any) => {
                                                setFieldValue('recordDate', value)
                                            }}
                                            minDate={minDate}
                                            maxDate={maxDate}
                                            component={FormDataPicker}
                                        />
                                        {/* <ReactCalendar/> */}
                                        <ErrorMessage name={`recordDate`} component='div' className='text-danger' />
                                    </CellStyle>
                                    <CellStyle lable='รายละเอียด'>
                                        <Field
                                            as='textarea'
                                            autoComplete='off'
                                            name='title'
                                            className={
                                                'form-control form-control-lg form-control-solid mb-3 mb-lg-0' +
                                                (errors.title && touched.title ? ' is-invalid' : '')
                                            }
                                            rows={3}
                                        />
                                        <ErrorMessage name={`title`} component='div' className='text-danger' />
                                    </CellStyle>
                                    <CellStyle lable='จำนวนคะแนน'>
                                        <Field
                                            name='point'
                                            className={
                                                'form-control form-control-lg form-control-solid mb-3 mb-lg-0' +
                                                (errors.point && touched.point ? ' is-invalid' : '')
                                            }
                                            maxLength={18}
                                            pattern={Pattern.Number2DigitMinus}
                                            component={FormInputNumber}
                                        />
                                        <ErrorMessage name={`point`} component='div' className='text-danger' />
                                    </CellStyle>
                                    <CellStyle lable='แนบไฟล์'>
                                        <Field
                                            className={
                                                'form-control form-control-lg form-control-solid' +
                                                (errors.file && errors.file ? ' is-invalid' : '')
                                            }
                                            name={'file'}
                                            onChange={async (val: any) => {
                                                try {
                                                    const res = await CommonService.uploadFile(
                                                        'img-special',
                                                        val.target.files[0]
                                                    )
                                                    setFieldValue('file', res.data.result.fileName)
                                                } catch (ex) { }
                                            }}
                                            url={API_IMG_SPECIAL_FILE}
                                            component={FormUpload}
                                        />
                                        <div className='text-danger'>* ขนาดไม่เกิน 800KB</div>
                                        <ErrorMessage name={`file`} component='div' className='text-danger' />
                                    </CellStyle>
                                </div>
                                {/* end::Scroll */}

                                <div className='card-footer d-flex py-6 px-9'>
                                    <button type='submit' className='btn btn-primary pe-5  me-10' disabled={loading}>
                                        {!loading && 'Save Changes'}
                                        {loading && (
                                            <span className='indicator-progress' style={{ display: 'block' }}>
                                                Please wait...
                                                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                            </span>
                                        )}
                                    </button>

                                    <button className='btn btn-light' onClick={() => navigate('/special')}> Back</button>
                                </div>
                            </>
                        </Form>
                    )}
                </Formik>
            </div>
        </>
    )
}

